// @ts-nocheck <-- this gets rid of all of the 'issues' compiling
// the comparator fields as strings and then converting
// them to functions at runtime.
import { ColDef } from 'ag-grid-community';
import {
  entityTypeGetter,
  footprintStatusGetter,
  seriesTitleGetter,
  seasonTitleGetter,
  titleGetter,
  milestoneStatusGetter,
  startDateFormatter,
  endDateFormatter,
  createdDateGetter,
  updatedDateGetter,
  milestoneDateGetter,
  milestoneCodeGetter,
  milestoneDetailGetter,
  destinationNameGetter,
  contentClassGetter,
  movieAssetIDGetter,
  hdrFrameSizeGetter,
  sdrFrameSizeGetter,
  hdrPictureAspectRatioGetter,
  sdrPictureAspectRatioGetter,
  hdrScanningFormatGetter,
  sdrScanningFormatGetter,
  complianceGetter,
  ratingsGetter
} from './crossPlatformValueGetters';
import { comparator, dateComparator } from '../comparators';
import { taskCIDGetter } from '../columnsHelpers/globalValueGetters';
import {
  activePresManifAudioComponentsGetter,
  activePresManifTimedTextComponentsGetter,
  activePresManifMarkersGetter,
  activePresManifAnnotationslabelsGetter,
  activePresManifMediaDurationGetter,
  activePresManifDynamicRangeIndicatorGetter
} from '../columnsHelpers/activePresManifCompGetters';

export function SetCrossPlatformValueGetters(columnDefs: ColDef[]) {
  columnDefs.forEach((cd) => {
    let keys = Object.keys(cd);
    if (keys.includes('valueGetter')) {
      if (typeof cd.valueGetter === 'string') {
        switch (cd.valueGetter) {
          case 'entityTypeGetter':
            cd.valueGetter = entityTypeGetter;
            break;
          case 'footprintStatusGetter':
            cd.valueGetter = footprintStatusGetter;
            break;
          case 'seriesTitleGetter':
            cd.valueGetter = seriesTitleGetter;
            break;
          case 'seasonTitleGetter':
            cd.valueGetter = seasonTitleGetter;
            break;
          case 'titleGetter':
            cd.valueGetter = titleGetter;
            break;
          case 'milestoneStatusGetter':
            cd.valueGetter = milestoneStatusGetter;
            // let ap = cd.cellRendererParams.activity ? 'Activity' : 'Process';
            // let f = cd.headerName!.split(' ').join('|');
            // cd.valueGetter = function (params) {
            //   return milestoneStatusGetter(params);
            // };
            break;
          case 'milestoneDateGetter':
            cd.valueGetter = milestoneDateGetter;
            break;
          case 'milestoneCodeGetter':
            cd.valueGetter = milestoneCodeGetter;
            break;
          case 'milestoneDetailGetter':
            cd.valueGetter = milestoneDetailGetter;
            break;
          case 'destinationNameGetter':
            cd.valueGetter = destinationNameGetter;
            break;
          case 'startDateFormatter':
            cd.valueGetter = startDateFormatter;
            break;
          case 'endDateFormatter':
            cd.valueGetter = endDateFormatter;
            break;
          case 'createdDateGetter':
            cd.valueGetter = createdDateGetter;
            break;
          case 'updatedDateGetter':
            cd.valueGetter = updatedDateGetter;
            break;
          case 'contentClassGetter':
            cd.valueGetter = contentClassGetter;
            break;
          case 'movieAssetIDGetter':
            cd.valueGetter = movieAssetIDGetter;
            break
          case 'ratingsGetter':
            cd.valueGetter = ratingsGetter;
            break;
          case 'taskCIDGetter':
            cd.valueGetter = (params) =>
              taskCIDGetter(params?.data?.tasks, 'mezzcreation');
            break;
          case 'activePresManifAudioComponentsGetter':
            cd.valueGetter = activePresManifAudioComponentsGetter;
            break;
          case 'activePresManifTimedTextComponentsGetter':
            cd.valueGetter = activePresManifTimedTextComponentsGetter;
            break;
          case 'activePresManifMarkersGetter':
            cd.valueGetter = activePresManifMarkersGetter;
            break;
          case 'activePresManifAnnotationslabelsGetter':
            cd.valueGetter = activePresManifAnnotationslabelsGetter;
            break;
          case 'activePresManifMediaDurationGetter':
            cd.valueGetter = activePresManifMediaDurationGetter;
            break;
          case 'activePresManifDynamicRangeIndicatorGetter':
            cd.valueGetter = activePresManifDynamicRangeIndicatorGetter;
          case 'hdrFrameSizeGetter':
            cd.valueGetter = hdrFrameSizeGetter;
            break;
          case 'sdrFrameSizeGetter':
            cd.valueGetter = sdrFrameSizeGetter;
            break;
          case 'hdrPictureAspectRatioGetter':
            cd.valueGetter = hdrPictureAspectRatioGetter;
            break;
          case 'sdrPictureAspectRatioGetter':
            cd.valueGetter = sdrPictureAspectRatioGetter;
            break;
          case 'hdrScanningFormatGetter':
            cd.valueGetter = hdrScanningFormatGetter;
            break;
          case 'sdrScanningFormatGetter':
            cd.valueGetter = sdrScanningFormatGetter;
            break;
          case 'complianceGetter':
            cd.valueGetter = complianceGetter;
            break;
          default:
            break;
        }
      }
    }
    if (keys.includes('comparator')) {
      if (typeof cd.comparator === 'string') {
        switch (cd.comparator) {
          case 'comparator':
            cd.comparator = comparator;
          case 'dateComparator':
            cd.comparator = dateComparator;
        }
      }
    }
  });
}
